
import React from 'react';
import LinkInputSection from './link-input/LinkInputSection';

interface GoogleMapsLinkInputProps {
  onLinkProcessed: (success: boolean, data?: any) => void;
  isProcessingLink: boolean;
  setIsProcessingLink: (loading: boolean) => void;
  onReset?: () => void;
  showReset?: boolean;
}

const GoogleMapsLinkInput: React.FC<GoogleMapsLinkInputProps> = (props) => {
  return <LinkInputSection {...props} />;
};

export default GoogleMapsLinkInput;
